
import React from "react";
import { Button } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useTranslation } from "react-i18next";

const ElevatorInfoButton = ({ info }) => {
  const isKorea = process.env.REACT_APP_TIMEZONE === 'Asia/Seoul';
  const isElevator = 
    info?.equipmentCtgr?.parent?.parent?.code === 'EV' ||  // 엘리베이터
    info?.equipmentCtgr?.parent?.parent?.code === 'ES' ||  // 에스컬레이터
    info?.equipmentCtgr?.code.startsWith('DOUBLE.') ||  // 에스컬레이터
    info?.equipmentCtgr?.code.startsWith('SINGLE.') ||  // 에스컬레이터
    info?.equipmentCtgr?.code.startsWith('GEARED.') ||  // 엘리베이터
    info?.equipmentCtgr?.code.startsWith('GEARLESS.') // 엘리베이터
    
  const { t } = useTranslation();
  const elevatorNo = info?.elevatorNo;

  if (!isKorea || !isElevator || !elevatorNo) return '';

  const openPage = () => {
      let url = `https://www.elevator.go.kr/qrcode.do?no_plaq=${elevatorNo}`;

      window.open(url, "_blank");
  };

  return (
    <Button
      variant="contained"
      style={{ border: "1px solid #2672f7", color:"#fff", margin: "3px" }}
      startIcon={<OpenInNewIcon />}
      onClick={openPage}
      disabled={!elevatorNo}
    >
      {t('message.common.btn.elevator.information.lookup')}
    </Button>
  );
};

export default ElevatorInfoButton;
